import { Route, Redirect, Link } from 'react-router-dom';
import PostRegister from '@packages/views/auth/postregister';
import generatePrivateRouteComponent from '@packages/views/privateRoute';
import NotFound from '@packages/views/notFound';
import generateLoginComponent from '@packages/views/auth/login';
import generateRegisterComponent from '@packages/views/auth/register';
import generateResetPasswordComponent from '@packages/views/auth/resetPassword';
import generateNewPasswordComponent from '@packages/views/auth/saveNewPassword';

// RBAC rules...
import rules from '../config/rbac-rules';
// Routing...
import DEFAULT_VIEW from '../config/routing';

const Login = generateLoginComponent(Route, Link, DEFAULT_VIEW, true);
const RegisterView = generateRegisterComponent(Route, Link, DEFAULT_VIEW, true);
const PrivateRoute = generatePrivateRouteComponent(rules, Route, Redirect);
const ResetPassView = generateResetPasswordComponent(Route, Link);
const NewPassView = generateNewPasswordComponent(Route, Link);

export { Login, PrivateRoute, RegisterView, PostRegister, NotFound, ResetPassView, NewPassView };
